import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { selectGroupGuid, useAppSelector } from '../../slices/commonSelectors';
import { toast } from 'react-toastify';
import { keys } from './useLocations';
import { LocationResourcesWithBooms } from 'types/locations';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';

export const useDeleteLocation = (
  resourceType?: LocationResourcesWithBooms
) => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);

  return useMutation({
    mutationFn: async (id: string) => {
      await axios.delete(`${config.apiGateway.ics_locations}/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [keys.locations, groupGuid, resourceType],
      });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });

      toast.success(`Location deleted`);
    },
    onError: () => {
      toast.error(`Failed to delete location`);
    },
  });
};
